//  const API = "https://firstdraft-yu5zwqlu7a-lz.a.run.app/api/v0"
const API = '/api/v0';
// "https://europe-west1-devdjuliapi.cloudfunctions.net/djuliwebap/api/v0";
import { getAuth } from 'firebase/auth';

export async function fetchFromAPI(endpointURL, opts) {
  try {
    const { method, body } = { method: 'POST', body: null, ...opts };
    const auth = getAuth();
    const user = auth.currentUser;

    const token =
      (user && (await user.getIdToken())) ||
      localStorage.getItem('accesstoken');

    const res = await fetch(`${API}/${endpointURL}`, {
      method,
      ...(body && { body: JSON.stringify(body) }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT',
      },
    });
    return res.json();
  } catch (err) {
    return {
      networkstatus: false,
      error: {
        error_message: err,
        suggestion: 'Please check your internet connection',
        error_code: 'NO_INTERNET_ACESS',
      },
    };
  }
}
